import {
    ReferenceManyField,
    Pagination,
    useRefresh,
    useTranslate,
    useListContext,
    ShowButton,
    Datagrid,
} from "react-admin";
import dayjs from "dayjs";
import { FunctionField } from "react-admin";
import {
    DateFieldMod,
    EmailFieldMod,
    TextFieldMod,
} from "../../../../../Component/Layouts/Field";
import { NoResults } from "Component/NoResults/NoResults";
import React, { useMemo, useState } from "react";
import "./style.css";
import inMemoryJwt from "Application/Auth/inMemoryJwt";

const MobileCardList = ({ subscriptionStatus, translate }) => {
    const { data, isLoading } = useListContext();

    if (isLoading || !data) return null;
    if (!data.length) return <NoResults />;

    return (
        <div className="chat-card-list">
            {data.map((record) => (
                <div key={record.id} className="chat-card">

                    <div className="chat-card-row">
                        <span className="chat-card-label">Name:</span>
                        <span className="chat-card-value">
              {record.name + " " + (record.lastName || "")}
            </span>
                    </div>

                    <div className="chat-card-row">
                        <span className="chat-card-label">Phone:</span>
                        <span className="chat-card-value">{record.phone || "—"}</span>
                    </div>

                    <div className="chat-card-row">
                        <span className="chat-card-label">Email:</span>
                        <span className="chat-card-value">
                            {record.email ? <a
                                className="chat-card-value_link"
                                href={`mailto:${record.email}`}
                                onClick={(e) => e.stopPropagation()}
                            >
            {record.email}
        </a> : "—"}</span>
                    </div>

                    <div className="chat-card-row">
                        <span className="chat-card-label">Last visit:</span>
                        <span className="chat-card-value">
              {record.last_message
                  ? new Intl.DateTimeFormat("en-GB", {
                      hour: "2-digit",
                      minute: "2-digit",
                      hourCycle: "h24",
                      year: "numeric",
                      month: "2-digit",
                      day: "numeric",
                  }).format(new Date(record.last_message))
                  : "—"}
            </span>
                    </div>

                    <div className="chat-card-row">
                        <span className="chat-card-label">Subscription public:</span>
                        <span className="chat-card-value">
              {record.public_next_payment_at
                  ? record.public_status === "active"
                      ? `${subscriptionStatus[record.public_status]} (${dayjs(
                          record.public_next_payment_at.startAt
                      ).format("DD/MM/YYYY")})`
                      : subscriptionStatus[record.public_status]
                  : translate("subscription.statuses.noSubscription")}
            </span>
                    </div>

                    <div className="chat-card-row">
                        <span className="chat-card-label">Subscription private:</span>
                        <span className="chat-card-value">
              {record.private_next_payment_at
                  ? record.private_status === "active"
                      ? `${subscriptionStatus[record.private_status]} (${dayjs(
                          record.private_next_payment_at
                      ).format("DD/MM/YYYY")})`
                      : subscriptionStatus[record.private_status]
                  : translate("subscription.statuses.noSubscription")}
            </span>
                    </div>

                    <div className="chat-card-action clients-card-action">
                        <ShowButton label="" resource="users" record={record} />
                    </div>
                </div>
            ))}
        </div>
    );
};

const ResponsiveClientsDatagrid = ({ subscriptionStatus, translate }) => {
    const [isMobile, setIsMobile] = React.useState(() => window.innerWidth < 768);

    React.useEffect(() => {
        const handler = () => setIsMobile(window.innerWidth < 768);
        window.addEventListener("resize", handler);
        return () => window.removeEventListener("resize", handler);
    }, []);

    if (isMobile) {
        return <MobileCardList subscriptionStatus={subscriptionStatus} translate={translate} />;
    }

    return (
        <Datagrid bulkActionButtons={false} empty={<NoResults />} rowClick={false} className="clients">
            <FunctionField source="name" label="Name" render={(record) => record.name + " " + (record.lastName || "")} />
            <TextFieldMod source="phone" />
            <EmailFieldMod source="email" />
            <DateFieldMod
                locales="en-GB"
                label="resources.users.fields.lastVisitDate"
                source="last_message"
                showTime
                options={{
                    hour: "2-digit",
                    minute: "2-digit",
                    hourCycle: "h24",
                    year: "numeric",
                    month: "2-digit",
                    day: "numeric",
                }}
            />
            <FunctionField
                label="resources.users.fields.subscriptionPublic"
                render={(record) =>
                    record.public_next_payment_at
                        ? record.public_status === "active"
                            ? `${subscriptionStatus[record.public_status]} (${dayjs(record.public_next_payment_at.startAt).format("DD/MM/YYYY")})`
                            : subscriptionStatus[record.public_status]
                        : translate("subscription.statuses.noSubscription")
                }
            />
            <FunctionField
                label="resources.users.fields.subscriptionPrivate"
                render={(record) =>
                    record.private_next_payment_at
                        ? record.private_status === "active"
                            ? `${subscriptionStatus[record.private_status]} (${dayjs(record.private_next_payment_at).format("DD/MM/YYYY")})`
                            : subscriptionStatus[record.private_status]
                        : translate("subscription.statuses.noSubscription")
                }
            />
            <ShowButton label="" resource="users" />
        </Datagrid>
    );
};

const ClientsTab = (props) => {
    const translate = useTranslate();
    const doctorType = inMemoryJwt.getUserType();
    const userRole = inMemoryJwt.getRoles();
    const [userDoctorType] = useState(
        userRole === "ROLE_ADMIN" || doctorType === "private" ? null : doctorType
    );

    const subscriptionStatus = useMemo(() => ({
        created: translate("subscription.statuses.created"),
        active: translate("subscription.statuses.active"),
        completed: translate("subscription.statuses.completed"),
        pending: translate("subscription.statuses.pending"),
        canceled: translate("subscription.statuses.canceled"),
        not_available: translate("subscription.statuses.notAvailable"),
    }), [translate]);

    const filters = {};
    if (userDoctorType) filters["doctorType"] = userDoctorType;

    return (
        <div className="patients-tab-content">
            <ReferenceManyField
                reference="users-list"
                target="doctor"
                label={false}
                pagination={<Pagination />}
                filter={filters}
            >
                <ResponsiveClientsDatagrid
                    subscriptionStatus={subscriptionStatus}
                    translate={translate}
                />
            </ReferenceManyField>
        </div>
    );
};

export default ClientsTab;